import React from "react";

const WIDGET_ORIGIN = "https://widget.busable.app";

// Journey params the widget's parseJourneyParams() reads. Anything else on the
// parent URL is site-local and must not be forwarded.
const JOURNEY_PARAMS = ["b_fr", "b_to", "b_ti", "b_st", "b_en", "b_so"];

// InfoMenu's activeLink keys mapped to widget view names.
export const VIEW_BY_LINK = {
    tripPlanner: "planner",
    schoolList: "schools",
    timetables: "timetables",
};

export function buildWidgetUrl({ operatorId, view, routeId, search }) {
    const path = routeId ? `${view}/${encodeURIComponent(routeId)}` : view;
    const params = new URLSearchParams({ embed: view });

    // Regions still on the widget should list regular passenger services only,
    // not school or charter runs.
    if (view === "timetables") {
        params.set("services", "regular");
    }

    if (view === "planner") {
        const parentParams = new URLSearchParams(search || "");
        JOURNEY_PARAMS.forEach((key) => {
            const value = parentParams.get(key);
            if (!value) return;
            // The widget only accepts a bare "now"; "now|<timestamp>" parses to null.
            params.set(key, key === "b_ti" && value.startsWith("now|") ? "now" : value);
        });
    }

    return `${WIDGET_ORIGIN}/${operatorId}/${path}?${params.toString()}`;
}

export default function BusableWidget({ operatorId, view, routeId, search }) {
    // Keyed so a view change replaces the element rather than mutating src,
    // which would push entries onto the parent's session history.
    return (
        <iframe
            key={`${view}/${routeId || ""}`}
            className="BusableWidget"
            src={buildWidgetUrl({ operatorId, view, routeId, search })}
            width="100%"
            style={{ border: "none" }}
            allow="geolocation"
            title={operatorId}
        />
    );
}
